import request from "@/utils/request";

// // 设置数据
// localStorage.setItem('key', 'value');

// // 获取数据
// const value = localStorage.getItem('key');

// // 删除数据
// localStorage.removeItem('key');
// 登录

// 上传文件

export function getupload(data) {
    return request({
        url: "/upload",
        method: "post",
        data,
    });
}
// 删除oss文件
export function getdeleteOssFile(data) {
    return request({
        url: "/deleteOssFile",
        method: "post",
        data,
    });
}


export function dcShopProductslist(data) {
    return request({
        url: "/dcShopProductslist",
        method: "post",
        data,
    });
}

export function dcShopProductsInfo(data) {
    return request({
        url: "/dcShopProductsInfo",
        method: "post",
        data,
    });
}
// 查询商家详情
export function dcShopsInfo(data) {
    return request({
        url: "/dcShopsInfo",
        method: "post",
        data,
    });
}
export function adddcShops(data) {
    return request({
        url: "/adddcShops",
        method: "post",
        data,
    });
}
export function dcShopslist(data) {
    return request({
        url: "/dcShopslist",
        method: "post",
        data,
    });
}
export function editdcShops(data) {
    return request({
        url: "/editdcShops",
        method: "post",
        data,
    });
}
export function adddcShopProducts(data) {
    return request({
        url: "/adddcShopProducts",
        method: "post",
        data,
    });
}
export function editdcShopProducts(data) {
    return request({
        url: "/editdcShopProducts",
        method: "post",
        data,
    });
}

export function dcOrdersinfo(data) {
    return request({
        url: "/dcOrdersinfo",
        method: "post",
        data,
    });
}
export function editdcOrders(data) {
    return request({
        url: "/editdcOrders",
        method: "post",
        data,
    });
}

export function guoqiao(data) {
    return request({
        url: "/guoqiao",
        method: "post",
        data,
    });
}
export function userEdit(data) {
    return request({
        url: "/userEdit",
        method: "post",
        data,
    });
}
export function dcTextsInfo(data) {
    return request({
        url: "/dcTextsInfo",
        method: "post",
        data,
    });
}

// http://hibachihomecs.com/api/?id=24&nickname=董